"use client";
import type { ReactElement } from "react";
import type { GanttLayout } from "./gantt-types";
export interface GanttSectionBackgroundLayerProps {
    ganttIdPrefix: string;
    layout: GanttLayout;
}
export function GanttSectionBackgroundLayer({ ganttIdPrefix, layout, }: GanttSectionBackgroundLayerProps): ReactElement {
    return (<>
      {layout.sectionRows.map((sectionRow) => (<rect key={`${ganttIdPrefix}-section-bg-${sectionRow.sectionIndex}`} x={0} y={sectionRow.y} width={layout.timelineWidth} height={sectionRow.height} fill={sectionRow.isCollapsed
                ? "rgba(102,254,193,0.025)"
                : "rgba(102,254,193,0.05)"} stroke="rgba(102,254,193,0.08)" strokeWidth={0.5}/>))}
    </>);
}
